var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5593E7",
    d: "M2.047 15.605L33.37 5.218 34.943 9.964 3.621 20.351z",
    transform: "translate(1 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M8.669 32.213c-1.258 0-2.432-.798-2.85-2.056L.154 13.072c-.252-.76-.193-1.573.166-2.29.359-.716.976-1.25 1.737-1.502L29.583.152c1.57-.518 3.272.334 3.792 1.903l5.255 15.847c.174.524-.11 1.09-.634 1.264-.527.176-1.091-.11-1.265-.634L31.477 2.685c-.174-.523-.74-.81-1.265-.634L2.687 11.179c-.254.084-.46.262-.58.5-.12.239-.14.51-.055.763l5.666 17.086c.173.523.74.806 1.263.634l1.63-.54c.524-.172 1.09.112 1.264.635.173.524-.111 1.09-.635 1.264l-1.63.54c-.311.103-.63.152-.941.152",
    transform: "translate(1 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4C5F2",
    d: "M15.925 21.213c-1.104 0-2 .896-2 2v18.001c0 1.1.9 2 2 2h29c1.104 0 2-.896 2-2v-18c0-1.105-.896-2-2-2h-29z",
    transform: "translate(1 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5593E7",
    d: "M20.925 36.214c.552 0 1 .447 1 1 0 .553-.448 1-1 1h-2c-.552 0-1-.447-1-1 0-.553.448-1 1-1h2zm7 0c.552 0 1 .447 1 1 0 .553-.448 1-1 1h-2c-.552 0-1-.447-1-1 0-.553.448-1 1-1h2zm7 0c.552 0 1 .447 1 1 0 .553-.448 1-1 1h-2c-.552 0-1-.447-1-1 0-.553.448-1 1-1h2zm7 0c.552 0 1 .447 1 1 0 .553-.448 1-1 1h-2c-.552 0-1-.447-1-1 0-.553.448-1 1-1h2z",
    transform: "translate(1 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M41.925 29.214c0 1.656-1.343 3-3 3h-1c-1.657 0-3-1.344-3-3 0-1.657 1.343-3 3-3h1c1.657 0 3 1.343 3 3",
    transform: "translate(1 3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtCreditCard);
export default __webpack_public_path__ + "static/media/art-credit-card.0594f13d6ee4a3002c5a053c203cccfc.svg";
export { ForwardRef as ReactComponent };